import { render, staticRenderFns } from "./SubmitSucceed.vue?vue&type=template&id=7422a1a0&scoped=true&"
import script from "./SubmitSucceed.vue?vue&type=script&lang=js&"
export * from "./SubmitSucceed.vue?vue&type=script&lang=js&"
import style0 from "./SubmitSucceed.vue?vue&type=style&index=0&id=7422a1a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7422a1a0",
  null
  
)

export default component.exports